import * as React from 'react';

import { Block } from 'emotion-jsxstyle';
import { EntityActions, EntityType } from 'common/entity';

import { AppState } from 'common/models/AppState';
import { Badge } from 'common/components/Badge';
import { Datetime } from 'common/components/Datetime';
import { InfiniteList } from 'common/components/InfiniteList';
import { toApiError } from 'common/utils/api';
import { Member } from 'common/api/models/Member';
import { Order } from 'common/api/models/Order';
import { OrderApi } from 'common/api/resources/OrderApi';
import { Link } from 'react-router-dom';
import { Money } from 'common/components/Money';
import { MemberLink } from 'common/components/link/MemberLink';
import { Loading } from 'common/components/Loading';

export interface MembersOrdersProps {
  appState: AppState;
  entityActions: EntityActions;
  member?: Member;
  onEdit: (org: Member) => void;
}
export interface MembersOrdersState {
  isLoading: boolean;
  isLoadingWoo?: boolean;
  orders: Order[];
  wooOrders: any[];
  next?: number;
  error?: string;
}

export class MembersOrders extends React.Component<MembersOrdersProps, MembersOrdersState> {
  state: MembersOrdersState = { isLoading: false, isLoadingWoo: false, orders: [], wooOrders: [] };

  componentDidMount() {
    this.reload();
  }

  reload = () => {
    if (this.props.member) {
      this.props.entityActions.refetch(EntityType.MEMBER, this.props.member!.id!);
      this.setState({ isLoading: true });
      OrderApi.getOrders({ memberId: this.props.member.id, from: this.state.next, limit: 20 }).then(
        res => {
          this.setState(s => ({
            orders: s.next ? [...s.orders, ...res.data] : res.data,
            isLoading: false,
            next: res.next,
          }));
          let memberIds: string[] = [];
          let productIds: string[] = [];
          for (let order of res.data) {
            memberIds.push(order.createId!);
            memberIds.push(order.accountId!);
            order.items!.map(item => {
              productIds.push(item.productId);
            });
          }
          this.props.entityActions.fetchMissingIds(EntityType.MEMBER, memberIds);
          this.props.entityActions.fetchMissingIds(EntityType.PRODUCT, productIds);
        },
        err => {
          this.setState({ error: toApiError(err), isLoading: false });
        }
      );
      if (this.props.appState.config && this.props.appState.config.config.enableWooCommerce === true) {
        this.setState({ isLoadingWoo: true });
        OrderApi.getWoocommerceOrders({ email: this.props.member.email }).then(
          res => {
            let wooData: any[] = res;
            this.setState(s => ({
              wooOrders: wooData,
              isLoadingWoo: false,
            }));
          },
          err => {
            this.setState({ error: toApiError(err), isLoadingWoo: false });
          }
        );
      }
    }
  };

  render() {
    return (
      <Block marginBottom="2rem">
        <InfiniteList hasMore={!!this.state.next} isLoading={this.state.isLoading} onLoadMore={this.reload}>
          <table
            className="table table-striped table-hover table-clickable"
            style={{ width: '100%' }}
            data-testid="membersOrders"
          >
            <thead>
              <tr>
                <th>Num</th>
                <th>Billed</th>
                <th>Paid</th>
                <th>Status</th>
                <th>Payment</th>
                <th>Placed</th>
                <th>Placed By</th>
              </tr>
            </thead>
            <tbody>
              {this.state.orders.map(o => (
                <tr key={o.id} data-number={o.number}>
                  <td>
                    <Link to={'/orders/' + o.number}>{o.number}</Link>
                  </td>
                  <td>
                    <Money value={o.billAmount!} />
                  </td>
                  <td>
                    <Money value={o.paymentAmount!} />
                  </td>
                  <td>
                    {o.status === Order.Status.PAID && <Badge type="success" text="Paid" />}
                    {o.status === Order.Status.PENDING && <Badge type="warning" text="Pending" />}
                    {o.status === Order.Status.CANCELLED && <Badge type="danger" text="Cancelled" />}
                  </td>
                  <td>
                    {o.transactionType === Order.TransactionType.CHECK && <span>Check</span>}
                    {o.transactionType === Order.TransactionType.CHARGE && <span>Charge</span>}
                  </td>
                  <td>
                    <Datetime at={o.createAt} />
                  </td>
                  <td>
                    <MemberLink member={this.props.appState.entities.member[o.createId!]} />
                  </td>
                </tr>
              ))}
              {this.props.appState.config &&
                this.props.appState.config.config.enableWooCommerce === true &&
                this.state.isLoadingWoo && (
                  <tr>
                    <td colSpan={7}>
                      <Loading message="Loading WooCommerce Orders..." />
                    </td>
                  </tr>
                )}
              {/* {this.props.appState.config &&
                this.props.appState.config.config.enableWooCommerce === true && !isLoading && error && (
                  <tr id="woo-error">
                    <td colSpan={7}>
                      <p className="text-danger">
                        WooCommerce: {error}
                      </p>
                    </td>
                  </tr>
                )} */}
              {this.props.appState.config &&
                this.props.appState.config.config.enableWooCommerce === true &&
                this.state.wooOrders.map(o => (
                  <tr key={o.id} data-number={o.number}>
                    <td>
                      <a target="_blank" href={o.wp_source + '/wp-admin/post.php?post=' + o.number + '&action=edit'}>
                        {o.number}
                      </a>
                    </td>
                    <td>${o.total}</td>
                    <td>&nbsp;</td>
                    <td>
                      {o.status !== 'pending payment' && o.status !== 'cancelled' && o.status}
                      {o.status === 'pending payment' && <Badge type="warning" text="Pending" />}
                      {o.status === 'cancelled' && <Badge type="danger" text="Cancelled" />}
                    </td>
                    <td>{o.payment_method_title}</td>
                    <td>
                      <Datetime at={o.date_created} />
                    </td>
                    <td>WooCommerce</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </InfiniteList>
      </Block>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Members/MembersOrders.tsx